// @ts-check

class FfSizeChart extends HTMLElement {
  constructor() {
    super();

    const titlesTab = this.querySelectorAll(".ff-table-tab-title");
    const ffSizeChartOpener = this.querySelector(".ff-product-size-chart");
    const tables = this.querySelectorAll(".ff-grid-size-chart");
    const modalSizeChart = this.querySelector(".ff-modal-size-chart");
    const ffCloseChartButton = this.querySelector(".ff-close-size-chart");
    const resetClass = (object, classChange) => {
      object.forEach((element, i) => {
        element.classList.add(classChange);
      });
    };

    document.body.appendChild(modalSizeChart);

    const addListener = (object, objectChange, resetObject) => {
      object.addEventListener("click", () => {
        resetObject && resetClass(resetObject, "ff-d-none");
        objectChange.classList.contains("ff-d-none")
          ? objectChange.classList.remove("ff-d-none")
          : objectChange.classList.add("ff-d-none");
      });
    };

    addListener(ffSizeChartOpener, modalSizeChart);
    addListener(ffCloseChartButton, modalSizeChart);

    titlesTab.length > 0 &&
      titlesTab.forEach((element, i) => {
        addListener(element, tables[i], tables);
      });
  }
}

if (!customElements.get("ff-size-chart")) {
  customElements.define("ff-size-chart", FfSizeChart);
}
